exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-more[data-v-79684b50]{height:24px;min-width:24px;background-color:#005086;border-radius:50%;color:#fff;margin-left:4px;cursor:pointer}.input-remark[data-v-79684b50]{width:100px}.input-minutes[data-v-79684b50]{width:95px}.add-or-sub[data-v-79684b50]{width:70px}", ""]);

// exports
